document.addEventListener('DOMContentLoaded', function() {

  // Sticky header scroll effect
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  // Add to cart feedback
  var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      var btn = form.querySelector('button[name="add"]');
      if (btn) {
        var originalText = btn.textContent;
        btn.textContent = 'Ajout en cours…';
        btn.classList.add('btn-loading');
        setTimeout(function() {
          btn.textContent = '✓ Ajouté au panier';
          btn.style.background = 'var(--sage)';
          btn.classList.remove('btn-loading');
          setTimeout(function() {
            btn.textContent = originalText;
            btn.style.background = '';
          }, 2500);
        }, 800);
      }
    });
  });

  // Mobile menu toggle
  window.toggleMenu = function() {
    var nav = document.getElementById('mobile-nav');
    if (nav) nav.classList.toggle('open');
  };

  // Close mobile menu on outside click
  document.addEventListener('click', function(e) {
    var nav = document.getElementById('mobile-nav');
    var burger = document.querySelector('.nav-burger');
    if (nav && burger && !nav.contains(e.target) && !burger.contains(e.target)) {
      nav.classList.remove('open');
    }
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Product image thumbnails
  var thumbs = document.querySelectorAll('.product-thumb');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = document.querySelector('.product-main-img img');
      var src = this.querySelector('img').src;
      if (mainImg && src) {
        mainImg.src = src;
        thumbs.forEach(function(t) { t.style.borderColor = 'transparent'; });
        this.style.borderColor = 'var(--terracotta)';
      }
    });
  });

  // FAQ toggle (global)
  window.toggleFaq = function(btn) {
    var answer = btn.nextElementSibling;
    var icon = btn.querySelector('.faq-icon');
    var isOpen = answer.style.maxHeight && answer.style.maxHeight !== '0px';
    document.querySelectorAll('.faq-answer').forEach(function(a) { a.style.maxHeight = '0'; });
    document.querySelectorAll('.faq-icon').forEach(function(i) { i.textContent = '+'; i.style.transform = ''; });
    if (!isOpen) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
      if (icon) { icon.textContent = '−'; icon.style.transform = 'rotate(180deg)'; }
    }
  };

});
